









































import Debug from 'debug'
import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import UiTaskHeaderComponent from "@/app/shared/components/ui/ui-task-header-component.vue";
import WrapperModalComponent from "@/app/shared/components/wrapper/wrapper-modal-component.vue";
import * as Api from "@/app/interaction/api";
import GalleryModalComponent from "@/app/static/gallery-modal-component.vue";
import HelpPopupComponent from "@/app/presenter/components/help-popup-component.vue";
import { GalleryState, GalleryItem, GalleryContent } from "./gallery-interfaces";

const debug = Debug('gallery-component')

interface InternalGalleryItem {
  imageSrc: string;
  title: string|null;
  content: string;
  touched: boolean;
}

@Component({
  components: {
    GalleryModalComponent,
    UiTaskHeaderComponent,
    WrapperModalComponent,
    HelpPopupComponent
  }
})
export default class GalleryComponent extends Vue
  implements Api.InteractiveComponent<GalleryState, GalleryContent> {

  @Prop({
    required: true
  })
  public meta: Api.InteractionComponentMeta;

  @Prop({
    required: true
  })
  public content: GalleryContent;

  @Prop({
    required: true
  })
  public state: GalleryState | null;

  private shows = false;

  private selectedIndex: number = -1;

  private internalItems: InternalGalleryItem[] = [];

  private mounted() {
    this.internalItems = this.content.items.map(x => ({
      imageSrc: x.imageSrc,
      title: x.title,
      content: x.content,
      touched: false
    }));

    if (this.state) {
      this.state.touched.forEach((touched, i) => {
        if (this.internalItems[i]) {
          this.internalItems[i].touched = touched;
        }
      });

      if (this.selectedIndex >= 0) {
        this.shows = true;
      }
    }
  }

  private showModal(index: number) {
    this.shows = true;
    this.selectItem(index);
  }

  private selectItem(index: number) {
    this.selectedIndex = index;

    let progressChanged = false
    if (!this.internalItems[index].touched) {
      this.internalItems[index].touched = true;
      progressChanged = true
    }

    this.emitInteractionStateChanged();

    if (progressChanged) {
      this.emitInteractionResultChanged();
    }
  }

  private closeModal() {
    this.shows = false;
  }

  @Emit("interaction-result-changed")
  public emitInteractionResultChanged() {
    let touchedItems = 0;

    for (let i in this.internalItems) {
      if (this.internalItems[i].touched) {
        touchedItems++;
      }
    }

    const progress = parseFloat((touchedItems / this.internalItems.length).toFixed(2));

    const result: Api.Result = {
      progress,
      status: progress < 1 ? 'incomplete' : 'completed'
    }

    debug('emitInteractionResultChanged', result);

    return result
  }

  @Emit("interaction-state-changed")
  public emitInteractionStateChanged() {
    const state: GalleryState = {
      touched: this.internalItems.map(item => item.touched || false)
    };

    debug('emitInteractionStateChanged', state);

    return state
  }
}
